import React from "react";
import { useTranslation } from "react-i18next";
import { Product } from "../../types/ArtWork";
import { LinkIcon } from "../LinkIcon";
import { ArtworkImage } from "../ArtworkImage";

export function ProductCard({ product }: { product: Product }) {
  const { t } = useTranslation();

  return (
    <article className="group art-card flex flex-col">
      <ArtworkImage
        src={product.imageURL}
        alt={product.name}
        aspectClass="aspect-square"
        imgClassName="transition-transform duration-500 group-hover:scale-105"
      />
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-display text-lg font-medium text-canvas-950">
          {product.name}
        </h3>
        {product.description && (
          <p className="mt-1 line-clamp-2 text-sm text-canvas-600">
            {product.description}
          </p>
        )}
        <div className="mt-auto flex items-center justify-between pt-4">
          <a
            href={product.URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-accent !px-4 !py-2 !text-xs"
          >
            <LinkIcon label="redbubble" className="h-3.5 w-3.5 text-white" />
            {t("artwork.getYours")}
          </a>
          <span className="text-xs text-canvas-500">
            {t("common.deliveryIncluded")}
          </span>
        </div>
      </div>
    </article>
  );
}
